import {createContext} from 'react';

export const AuthContext = createContext({
  isReady: false,
  isAuthenticated: false,
  authState: null,
  account: undefined,
  claims: {},
  signInWithRedirect: () => undefined,
  handleLogin: () => undefined,
  signOut: () => undefined
});
